import { KeywordService, UserService } from '@common/lib/api';
import to from '@common/lib/common/to';
import * as keyword from './types';
import * as common from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import { downloadFile } from '@common/lib/common/utils';
import * as user from '@common/store/modules/user/types';

const actions = {
  async [keyword.FETCH_BENEFITS](context, params) {
    const { data } = await KeywordService.getBenefitListByArea(params);
    context.commit(keyword.SET_BENEFITS, data);
    return data;
  },
  async [keyword.FETCH_SECTIONS](context, params) {
    const { data } = await KeywordService.getSectionList(params);
    context.commit(keyword.SET_SECTIONS, data);
    return data;
  },
  async [keyword.FETCH_SECTIONS_AREA](context, params) {
    const { data } = await KeywordService.getSectionListByArea(params);
    context.commit(keyword.SET_SECTIONS_AREA, data);
    return data;
  },
  async [keyword.FETCH_STORES](context, params) {
    const { data } = await KeywordService.getStoreList(params);
    context.commit(keyword.SET_STORES, data);
    return data;
  },
  async [keyword.CREATE_KEYWORD_STORE](context, payload) {
    await KeywordService.addStoreKeyword(payload);
  },
  async [keyword.DELETE_KEYWORD_STORE](context, params) {
    await KeywordService.removeStoreKeyword(params);
  },
  async [keyword.DELETE_SECTION](context, params) {
    await KeywordService.removeSection(params);
  },
  async [keyword.FETCH_BENEFITS_OWNER](context) {
    const { data } = await KeywordService.getStoreMeList();
    context.commit(keyword.SET_BENEFITS, data);
    return data;
  },
  async [keyword.CREATE_KEYWORD](context, params) {
    await KeywordService.addSection(params);
  },
  async [keyword.FETCH_STOREKEYWORD](context, params) {
    const { data } = await KeywordService.getKeywordStoreById(params);
    context.commit(keyword.SET_STOREKEYWORD, data);
    return data;
  },
  async [keyword.FETCH_BENEFITS_BY_KEYWORDID](context, params) {
    const { data } = await KeywordService.getBenefitsByKeywordId(params);
    context.commit(keyword.SET_BENEFITS, data);
    return data;
  },
  async [keyword.PUT_SECTION_SORT](context, params) {
    await KeywordService.sortSection(params);
  },
  async [keyword.EXCEL_DOWNLOAD_SECTION](context, params) {
    const response = await KeywordService.downloadKeywordSectionExcel(params);
    downloadFile(response);
  },
  async [keyword.FETCH_STORE_KEYWORD](context, params) {
    //미정
    const { data } = await KeywordService.getStoreKeywordListByKeywordId(
      params,
    );
    context.commit(keyword.SET_BENEFITS, data);
    return data;
  },
};

export default actions;
